export default "__VITE_PUBLIC_ASSET__fd7401ab__"